"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.productsErrorSelector = exports.productDataSelector = exports.productsDataSelector = void 0;

var _reselect = require("reselect");

var productsSelector = function productsSelector(state) {
  return state.products;
};

var productsDataSelector = (0, _reselect.createSelector)(productsSelector, function (products) {
  return products.data;
});
exports.productsDataSelector = productsDataSelector;
var productDataSelector = (0, _reselect.createSelector)(productsSelector, function (products) {
  return products.data ? products.data[0] : null;
});
exports.productDataSelector = productDataSelector;
var productsErrorSelector = (0, _reselect.createSelector)(productsSelector, function (products) {
  return products.error;
});
exports.productsErrorSelector = productsErrorSelector;
var _default = {
  productsDataSelector: productsDataSelector,
  productDataSelector: productDataSelector,
  productsErrorSelector: productsErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map